import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input'];

  connect() {
    this.inputTarget.addEventListener('change', this.validateDate);
  }

  validateDate = () => {
    const inputValue = this.inputTarget.value;
    const formattedValue = inputValue.split('-').reverse().join('-');
    const timestamp = Date.parse(formattedValue);

    const invalidDate = this.isInvalidDate(timestamp, inputValue);
    const invalidFormat = this.isInvalidFormat(inputValue);
    if (invalidDate || invalidFormat) {
      this.inputTarget.value = this.formatDate(new Date());
      this.dispatchInputEvent();
      const warningMessage = invalidDate
        ? 'Wybrana data była nieprawidłowa i została automatycznie poprawiona.'
        : 'Wybrany format daty był nieprawidłowy i został automatycznie poprawiony.';
      this.displayWarning(warningMessage);
    }
  };

  isInvalidDate = (timestamp, value) =>
    Number.isNaN(timestamp) || timestamp === '' || timestamp === null || value.length !== 10;

  isInvalidFormat = (value) => {
    const regExp = /^\d{2}-\d{2}-\d{4}$/;
    return !regExp.test(value);
  };

  displayWarning = (message) => {
    toastr.warning(message, null, { timeOut: 10000 });
  };

  formatDate = (date) => date.toISOString().split('T')[0].split('-').reverse().join('-');

  dispatchInputEvent = () => this.inputTarget.dispatchEvent(new Event('input'));
}
